import { useState } from "react";

export function UseDisclosure(initial = false) {
  const [isOpen, setOpen] = useState(initial);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);
  const toggle = () => setOpen((p) => !p);

  return { isOpen, onOpen, onClose, toggle };
}
